<!-- The sitemap as the blog page (owner 2026-10-12): the Apps & Plugins hero with a chip per group, then a row per
     group in the footer's order, the group's short card at the left and its pages as small cards at the right -->
<div class="pl-page">

  <header class="pl-hero">
    <div class="pl-hero-inner">
      <h1 class="tools-title">Sitemap</h1>
      <nav class="pl-chips" aria-label="Sitemap groups">
        <a *ngFor="let g of GROUPS" class="pl-chip" [attr.href]="'#sm-' + g.key" (click)="jumpTo( g.key, $event )">
          <span>{{ g.name }}</span>
        </a>
      </nav>
    </div>
  </header>

  <section *ngFor="let g of GROUPS" class="bl-box" [id]="'sm-' + g.key" tabindex="-1">
    <header class="bl-head">
      <span class="bl-eyebrow"><img class="bl-eyebrow-logo" [src]="BRAND.logo.main" alt="" width="15" height="15"/>{{ g.eyebrow }}</span>
      <h2 class="bl-title">
        <a *ngIf="g.link; else plainTitle" class="sm-title-link" [routerLink]="g.link">{{ g.name }}</a>
        <ng-template #plainTitle>{{ g.name }}</ng-template>
      </h2>
      <p class="bl-lead">{{ g.lead }}</p>
      <ul class="bl-facts">
        <li>{{ g.count }} {{ g.count === 1 ? g.unit : g.units }}</li>
      </ul>
    </header>

    <div class="bl-grid sm-pages" [ngSwitch]="g.key">

      <!-- Apps & Plugins, by platform -->
      <ng-container *ngSwitchCase="'apps'">
        <div class="sm-sub" *ngFor="let line of PLUGINS">
          <p class="sm-subhead">{{ line.name }}</p>
          <div class="sm-grid">
            <a *ngFor="let product of line.products" class="sm-item"
               [attr.href]="productHref( product, line )" (click)="redirectToProductUrl( product, line, $event )">
              <img class="sm-icon" [src]="product.logo" alt="" width="28" height="28" loading="lazy" decoding="async"/>
              <span class="sm-name">{{ product.name }}</span>
            </a>
          </div>
        </div>
      </ng-container>

      <!-- Themes, by category -->
      <ng-container *ngSwitchCase="'themes'">
        <div class="sm-sub" *ngFor="let line of THEMES">
          <p class="sm-subhead">{{ line.name }}</p>
          <div class="sm-grid">
            <a *ngFor="let product of line.products" class="sm-item"
               [routerLink]="URLS.theme" [queryParams]="{ product: product.key, category: line.name }">
              <img class="sm-icon sm-icon-round" [src]="product.logo" alt="" width="28" height="28" loading="lazy" decoding="async"/>
              <span class="sm-name">{{ product.name }}</span>
            </a>
          </div>
        </div>
      </ng-container>

      <!-- Tools, in the tools page's groups -->
      <ng-container *ngSwitchCase="'tools'">
        <div class="sm-sub" *ngFor="let group of TOOL_GROUPS">
          <p class="sm-subhead">{{ group.name }}</p>
          <div class="sm-grid">
            <a *ngFor="let tool of group.tools" class="sm-item" [routerLink]="tool.url">
              <img class="sm-icon" [src]="tool.logo" alt="" width="28" height="28" loading="lazy" decoding="async"/>
              <span class="sm-name">{{ tool.name }}</span>
            </a>
          </div>
        </div>
      </ng-container>

      <!-- Services -->
      <ng-container *ngSwitchCase="'services'">
        <div class="sm-grid">
          <ng-container *ngFor="let line of SERVICES">
            <a *ngFor="let product of line.products" class="sm-item sm-item-text"
               [attr.href]="productHref( product, line )" (click)="redirectToProductUrl( product, line, $event )">
              <span class="sm-name">{{ product.name }}</span>
            </a>
          </ng-container>
        </div>
      </ng-container>

      <!-- Company & Resources -->
      <ng-container *ngSwitchCase="'company'">
        <div class="sm-grid">
          <ng-container *ngFor="let page of COMPANY_LINKS">
            <a *ngIf="!page.isExternal" class="sm-item sm-item-text" [routerLink]="page.url"><span class="sm-name">{{ page.name }}</span></a>
            <a *ngIf="page.isExternal" class="sm-item sm-item-text" [href]="page.url" target="_blank" rel="noopener"><span class="sm-name">{{ page.name }}</span></a>
          </ng-container>
        </div>
      </ng-container>

      <!-- Legal -->
      <ng-container *ngSwitchCase="'legal'">
        <div class="sm-grid">
          <a *ngFor="let page of LEGAL_LINKS" class="sm-item sm-item-text" [routerLink]="page.url"><span class="sm-name">{{ page.name }}</span></a>
        </div>
      </ng-container>

    </div>
  </section>
</div>
